/**
 * Mutation to create a marketplace_seller_feature record
 */
const createSellerFeatureMutation = `
mutation CreateSellerFeature($fields: CreateMarketplace_seller_featureFieldsInput) {
  createMarketplace_seller_feature(input: { fields: $fields }) {
    marketplace_seller_feature {
      objectId
      enabled
      feature_pointer {
        objectId
        name
        label
      }
    }
  }
}`.replace(/\r?\n|\r/g, "").replace(/\t/g, " ");

export default createSellerFeatureMutation;
